import { render, staticRenderFns } from "./surroundBox2.vue?vue&type=template&id=22591e9a&scoped=true"
import script from "./surroundBox2.vue?vue&type=script&lang=js"
export * from "./surroundBox2.vue?vue&type=script&lang=js"
import style0 from "./surroundBox2.vue?vue&type=style&index=0&id=22591e9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22591e9a",
  null
  
)

export default component.exports